import api from "../../../services/api.service";

export const catalogModule = {
    namespaced: true,
    state: {
        items: {},
        orders: {},
    },
    getters: {
        canRead: (state, getters, rootState, rootGetters) => rootGetters['user/canRead']('catalog'),
        canEdit: (state, getters, rootState, rootGetters) => rootGetters['user/canEdit']('catalog'),
        allItems: state => Object.values(state.items),
        allOrders: state => Object.values(state.orders),
        getItemById: state => id => state.items[id],
        getOrderById: state => id => state.orders[id],
    },
    mutations: {
        setItems(state, items) {
            const map = {};
            (items || []).forEach(i => { map[i.id] = i; });
            state.items = map;
        },
        setOrders(state, orders) {
            const map = {};
            (orders || []).forEach(o => { map[o.id] = o; });
            state.orders = map;
        },
        updateItem(state, item) {
            if (item && item.id) state.items = { ...state.items, [item.id]: item };
        },
        updateOrder(state, order) {
            if (order && order.id) state.orders = { ...state.orders, [order.id]: order };
        },
        removeItem(state, id) {
            const copy = { ...state.items };
            delete copy[id];
            state.items = copy;
        },
        removeOrder(state, id) {
            const copy = { ...state.orders };
            delete copy[id];
            state.orders = copy;
        },
    },
    actions: {
        // ─── Items ───
        loadItems({ commit }, { activeOnly, branchId } = {}) {
            const params = {};
            if (activeOnly) params.activeOnly = true;
            if (branchId) params.branchId = branchId;
            return api.sendRequest('catalog/item/get', params).then(ans => {
                commit('setItems', ans['CatalogItems']);
                return ans['CatalogItems'];
            });
        },
        getItem(_, id) {
            return api.get('catalog/item/' + id).then(ans => ans['CatalogItem']);
        },
        addItem({ commit }, item) {
            return api.sendRequest('catalog/item/add', {}, item).then(ans => {
                commit('updateItem', ans['CatalogItem']);
                return ans['CatalogItem'];
            });
        },
        updateItem({ commit }, { id, item }) {
            return api.sendRequest('catalog/item/update/' + id, {}, item).then(ans => {
                commit('updateItem', ans['CatalogItem']);
                return ans['CatalogItem'];
            });
        },
        deleteItem({ commit }, id) {
            return api.sendRequest('catalog/item/delete/' + id, {}).then(() => {
                commit('removeItem', id);
            });
        },
        // ─── Orders ───
        loadOrders({ commit }, { status } = {}) {
            const params = {};
            if (status) params.status = status;
            return api.sendRequest('catalog/order/get', params).then(ans => {
                commit('setOrders', ans['CatalogOrders']);
                return ans['CatalogOrders'];
            });
        },
        loadMyOrders({ commit }) {
            return api.sendRequest('catalog/order/my', {}).then(ans => {
                commit('setOrders', ans['CatalogOrders']);
                return ans['CatalogOrders'];
            });
        },
        createOrder(_, { buildingId, items }) {
            return api.sendRequest('catalog/order', {}, { buildingId, items }).then(ans => ({
                order: ans['CatalogOrder'],
                clientSecret: ans['clientSecret'],
                publishableKey: ans['publishableKey'],
            }));
        },
        confirmOrder({ commit }, { orderId, paymentIntentId }) {
            return api.sendRequest('catalog/order/' + orderId + '/confirm', {}, { paymentIntentId }).then(ans => {
                commit('updateOrder', ans['CatalogOrder']);
                return ans['CatalogOrder'];
            });
        },
        updateOrderStatus({ commit }, { orderId, status }) {
            return api.sendRequest('catalog/order/' + orderId + '/status', {}, { status }).then(ans => {
                commit('updateOrder', ans['CatalogOrder']);
                return ans['CatalogOrder'];
            });
        },
        deleteOrder({ commit }, orderId) {
            return api.sendRequest('catalog/order/' + orderId + '/delete', {}).then(() => {
                commit('removeOrder', orderId);
            });
        },
    },
};
